import { GridItem, Text } from '@chakra-ui/react';

interface FieldProps {
  label: string;
  value: string | number;
}

const Field = ({ label, value }: FieldProps) => (
  <GridItem>
    <Text color={'text.secondary'} fontSize={'xs'}>
      {label.charAt(0).toUpperCase() + label.slice(1)}
    </Text>
    <Text color={'text.primary'} fontSize={'sm'} whiteSpace="pre-line">
      {value !== '' ? value : '-'}
    </Text>
  </GridItem>
);

export default Field;
